export const pidSimulationTimeout = 9; // In minutes, CNS timeout is 10 min

export enum CnsOperationType {
    RA_SEND_MH = "RA_SEND_MH",
    RA_CANCEL_MH = "RA_CANCEL_MH",
    PID_REQUEST_SIMULATION = "PID_REQUEST_SIMULATION",
    PID_VALIDATE_SIMULATION = "PID_VALIDATE_SIMULATION",
    PID_CONTEST_SIMULATION = "PID_CONTEST_SIMULATION"
}

export function extractErrorsFromCnsAnomalie(anomalies: Array<TAnomalie>) {
    const errors = new Map<string, string>();
    anomalies.forEach((anomalie) => {
        if (anomalie.motif !== null) {
            errors.set(anomalie.identifiantAnomalie, anomalie.motif);
        }
    })

    return errors;
}

export default {

    async status(port: string): Promise<Response> {
        return fetch(
            `http://localhost:${port}/econnector/status`, {
            method: 'GET',
            headers: {
                'X-CNS': 'CNS'
            }
        });
    },

    async createSimulation(port: string, gpCode: string, xmlRequest: string): Promise<TSimulationMedecinRetour> {
        const response = await fetch(
            `http://localhost:${port}/econnector/pid/${gpCode}/request-simulation`, { // Todo gpCode
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
                'X-CNS': 'CNS'
            },
            body: xmlRequest,
        });
        return response.json();
    },

    async sendMh(port: string, gpCode: string, xmlRequest: string): Promise<TDepotDocumentRetour> {
        const response = await fetch(
            `http://localhost:${port}/econnector/ra/${gpCode}/send-MH`, { // Todo gpCode
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
                'X-CNS': 'CNS'
            },
            body: xmlRequest,
        });
        return response.json();
    },

    async cancelMh(port: string, gpCode: string, xmlRequest: string): Promise<TAnnulationRetour> {
        const response = await fetch(
            `http://localhost:${port}/econnector/ra/${gpCode}/cancel-MH`, { // Todo gpCode
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
                'X-CNS': 'CNS'
            },
            body: xmlRequest,
        });
        return response.json();
    },

    async contestSimulation(port: string, gpCode: string, xmlRequest: string): Promise<TContestationSimulationMedecinRetour> {
        const response = await fetch(
            `http://localhost:${port}/econnector/pid/${gpCode}/contest-simulation`, { // Todo gpCode
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
                'X-CNS': 'CNS'
            },
            body: xmlRequest,
        });
        return response.json();
    },

    async validateSimulation(port: string, gpCode: string, xmlRequest: string): Promise<TPaiementMedecinRetour> {
        const response = await fetch(
            `http://localhost:${port}/econnector/pid/${gpCode}/validate-simulation`, { // Todo gpCode
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
                'X-CNS': 'CNS'
            },
            body: xmlRequest,
        });

        return response.json();
    },
}

export interface TUTARetour {
    identifiantReponseSimulation: string;
    matricule: number;
    idMemoireHonoraire: string;
    totalPartStatutaire: number;
    totalParticipationPersonelle: number;
    sommeTotale: number;
    anomalies?: Array<TAnomalie>;
    lignes: Lignes;
}

export interface TDepotDocumentRetour {
    document?: TDocument;
    anomalies?: Array<TAnomalie>;
}

export interface TDocument {
    identifiantExterneDocument: string;
    statut: boolean;
}

export interface TAnnulationRetour {
    identifiantExterneAnnulation: string;
    statut: boolean;
    anomalies?: Array<TAnomalie>;
}

export interface TSimulationMedecinRetour {
    utaretour?: TUTARetour;
}

export interface TPaiementMedecinRetour {
    montantPartStatutaire: number;
    montantRecouvrement: number;
    montantPaye: number;
    identifiantRecouvrement?: string;
    identifiantInitiationPaiement: string;
    anomalies?: Array<TAnomalie>;
}

export interface TLigneUTARetour {
    identifiantPrestation: string;
    nombreActeRembourse: number;
    partStatutaire: number;
    participationPersonelle: number;
    montantOpposable: number;
    anomalies?: Array<TAnomalie>;
}

export interface TContestationSimulationMedecinRetour {
    identifiantReponseContestation: string;
    anomalies?: Array<TAnomalie>;
}

export interface TAnomalie {
    identifiantAnomalie: string;
    type: string;
    code: string;
    motif?: string;
}

export interface Lignes {
    ligneUTARetour?: Array<TLigneUTARetour>;
}
